import useFormatDate from '@/src/hooks/date/useFormatDate'
import { AirportInfo, JsonsData, TimeInfo } from '@/src/types/flight'
import { convertDDMMYYYYToISO } from '@/src/utils/date/convertDateFormat'
import { Typography, Box } from '@mui/material'

export interface FlightInfoProps {
    timeInfo : TimeInfo & {
            airportCode: string
            airportName: AirportInfo
            terminal: string
        }
    jsonsAP: JsonsData['ap']
}

const FlightInfo: React.FC<FlightInfoProps> = ({ timeInfo, jsonsAP }) => {
    const { formatDate } = useFormatDate()
    const airportInfo = jsonsAP?.[timeInfo.airportCode]
    return (
        <Box
            sx={{ mb: 1 }}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            alignItems={'flex-start'}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body1" fontWeight="bold" fontSize={'18px'}>
                    {timeInfo.time}
                </Typography>
                <Typography variant="body2" color="text.primary">
                    {timeInfo.airportCode} – {airportInfo?.n},{' '}
                    <Typography component="span" variant="body2" color="text.secondary">
                        {airportInfo?.c}
                    </Typography>
                </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary">
                {formatDate(convertDDMMYYYYToISO(timeInfo.date), 'ddd, DD MMM')}
            </Typography>
        </Box>
    )
}

export default FlightInfo
